import { apiClient } from '@/core/api';
import type { PresenceDto, PresenceSettings } from './types';

/** `GET /api/realtime/presence/` — who in the org is online. Staff only. */
export async function getPresence(signal?: AbortSignal): Promise<PresenceDto> {
  const { data } = await apiClient.get<PresenceDto>('/realtime/presence/', { signal });
  return data;
}

export async function getPresenceSettings(): Promise<PresenceSettings> {
  const { data } = await apiClient.get<PresenceSettings>('/realtime/presence/settings/');
  return data;
}

export async function updatePresenceSettings(input: PresenceSettings): Promise<PresenceSettings> {
  const { data } = await apiClient.patch<PresenceSettings>('/realtime/presence/settings/', input);
  return data;
}
